
import { WhiteWrapper, Wrapper } from "../../Common/styles.common";
import React, { useEffect, useState } from "react";
import { strings } from "utils/constants/strings";
import useVendorStore from "../../HomePage/useVendorStore";
import { Loader } from "../../Common/Loader";
import PoCard from "../PoCard";
import { STATUS_BEGIN, STATUS_DONE, STATUS_FAIL, SERVICE_PO_SOURCE_LIST_VIEW } from "utils/constants/others";
import InfiniteScroll from "react-infinite-scroll-component";
import ShowToast from "../../Common/Toast";
import BackButton from "../../Button/BackButton";
import { useParams } from "react-router-dom";

const ServicePoView = () => {
  const { type } = useParams(); // 'pending-invoices' or 'rejected-invoices'
  const searchServicePurchaseOrders = useVendorStore((state) => state.searchServicePurchaseOrders);
  const searchServicePurchaseOrdersStatus = useVendorStore((state) => state.searchServicePurchaseOrdersStatus);
  const servicePurchaseOrders = useVendorStore((state) => state.servicePurchaseOrders);

  const outletId = window.localStorage.getItem("outlet_id");
  const [showLoader, setShowLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [poCreator, setPoCreator] = useState("");
  const [openCallModal, setOpenCallModal] = useState(false);

  useEffect(() => {
    if (searchServicePurchaseOrdersStatus === STATUS_BEGIN) {
      setShowLoader(true);
    }
    if (searchServicePurchaseOrdersStatus === STATUS_DONE) {
      setShowLoader(false);
    }
    if (searchServicePurchaseOrdersStatus === STATUS_FAIL) {
      setShowLoader(false);
      setShowToast(true);
    }
  }, [searchServicePurchaseOrdersStatus]);

  useEffect(() => {
    // Make API call based on type
    const pageSize = 20;
    const params = {
      vendor_id: parseInt(outletId),
      page_number: 0 * pageSize,
      page_size: pageSize,
      ...(type === "pending-invoices"
        ? { is_doc_uploaded: false }
        : { invoice_status: "REJECTED" }
      )
    };
    
    searchServicePurchaseOrders(params, null, SERVICE_PO_SOURCE_LIST_VIEW, true);
    setPageNumber(0);
  }, [type]);

  const handleCall = () => {
    const formattedPhoneNumber = phoneNumber.replace(/\s/g, '');
    window.location.href = `tel:+91${formattedPhoneNumber}`;
  };

  const loadNextPage = () => {
    const nextPage = pageNumber + 1;
    const pageSize = 20;
    const params = {
      vendor_id: parseInt(outletId),
      page_number: nextPage * pageSize,
      page_size: pageSize,
      ...(type === "pending-invoices"
        ? { is_doc_uploaded: false }
        : { invoice_status: "REJECTED" }
      )
    };
    
    searchServicePurchaseOrders(params, null, SERVICE_PO_SOURCE_LIST_VIEW, false);
    setPageNumber(nextPage);
  };

  let cards = [];
  if (servicePurchaseOrders && servicePurchaseOrders.length) {
    for (let index = 0; index < servicePurchaseOrders.length; index++) {
      cards.push(
        <PoCard
          key={index}
          po={servicePurchaseOrders[index]}
          source={"service"}
          openCallModal={openCallModal}
          setOpenCallModal={setOpenCallModal}
          setPhoneNumber={setPhoneNumber}
          setPoCreator={setPoCreator}
        />
      );
    }
  }

  const getHeaderText = () => {
    return type === "pending-invoices" 
      ? strings.pendingInvoicesString 
      : strings.rejectedInvoicesString;
  };

  return (
    <React.Fragment>
      <Wrapper>
        <WhiteWrapper>
          <div className="d-flex align-items-center">
            <BackButton pathName={"/"} />
            <span className="fs-16 fw-600">{getHeaderText()}</span>
          </div>
        </WhiteWrapper>
        {showLoader && pageNumber === 1 ? (
          <Loader />
        ) : (
          <InfiniteScroll
            className="infinite-scroll"
            height={"90%"}
            dataLength={cards.length}
            hasMore={true}
            next={loadNextPage}
            loader={<Loader isScrollLoader={true} />}
          >
            {cards}
          </InfiniteScroll>
        )}
      </Wrapper>
      {showToast ? (
        <ShowToast errorMsg="Failed to load service purchase orders" />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default ServicePoView;
